import { AppBar, Toolbar } from '@mui/material';
import { Logo } from 'shared/logos';
import { SxProps, Theme } from '@mui/material';

const rootStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
};
export function HeaderPublic() {
  return (
    <AppBar position='static'>
      <Toolbar sx={rootStyles}>
        <Logo />
      </Toolbar>
    </AppBar>
  );
}
